import { useEffect, useState } from "react";
//material-ui
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

// Define the CSS for pagination
const styles = {
  root: {
    flexShrink: 0,
    marginLeft: "20px",
  },
  pageNumber: {
    display: "flex",
    alignItems: "center",
    marginLeft: "20px",
  },
  pageNumberButton: {
    padding: "10px 15px",
    border: "none",
    margin: "0 5px",
    borderRadius: "10px",
    cursor: "pointer",
    color: "#000",
    backgroundColor: "#fff",
  },
  activePageNumberButton: {
    backgroundColor: "#3f51b5",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#303f9f",
    },
  },
};

const Pagination = (props) => {
  const [pages, setPages] = useState([]);
  const {
    type,
    // server props
    serverPage,
    serverPerPage,
    count,
    onPageChange,
    onRowsPerPageChange,
    // client props
    clientPage,
    totalPages,
    setCurrentPage,
    totalData,
  } = props;

  // Client pagination
  const onPageChangeClient = (page) => {
    if (typeof setCurrentPage === "function") {
      setCurrentPage(page);
    } else if (typeof onPageChange === "function") {
      onPageChange(null, page);
    }
  };

  const effectiveTotalPages = totalPages || Math.ceil(totalData / serverPerPage) || 0;
  const effectiveCurrentPage = clientPage || (type === "client" ? serverPage + 1 : serverPage);

  useEffect(() => {
    const range = Math.min(3, effectiveTotalPages); // Show up to 3 pages
    const start = Math.max(1, effectiveCurrentPage - Math.floor(range / 2));
    const end = Math.min(start + (range - 1), effectiveTotalPages);

    const pageNumbers = Array.from(
      { length: end - start + 1 },
      (_, i) => start + i
    );
    setPages(pageNumbers);
  }, [effectiveCurrentPage, effectiveTotalPages]);

  // Server pagination

  // count of pagination
  const totalCount = Math.min((serverPage + 1) * serverPerPage, totalData);
  const totalCounts = serverPerPage * serverPage;
  const rangeStart = totalCounts - serverPerPage + 1;
  const rangeEnd = Math.min(totalCounts, totalData);

  //firstPage button
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };
  // back button
  const handleBackButtonClick = (event) => {
    onPageChange(event, serverPage - 1);
  };

  //next page button
  const handleNextButtonClick = (event) => {
    onPageChange(event, serverPage + 1);
  };

  //last page button
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / serverPerPage) - 1));
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(totalData / serverPerPage);
    const pageNumbers = [];
    for (let i = 0; i < totalPages; i++) {
      pageNumbers.push(
        <button
          key={i}
          style={{
            ...styles.pageNumberButton,
            ...(i === serverPage ? styles.activePageNumberButton : {}),
          }}
          onClick={(event) => onPageChange(event, i)}
        >
          {i + 1}
        </button>
      );
    }
    return pageNumbers;
  };

  return (
    <div className="" style={{ padding: "10px 20px" }}>
      {type === "server" && totalData > 0 && (
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center justify-content-center">
            <span className="text-white fw-semibold fs-6">Row Per Page :-</span>
            <select
              className="mx-2 pageOption"
              onChange={(e) => onRowsPerPageChange(e.target.value)}
            >
              <option className="fs-6 fw-semibold" value="5" >
                5
              </option>
              <option className="fs-6 fw-semibold" value="10" selected>
                10
              </option>
              <option className="fs-6 fw-semibold" value="25">
                25
              </option>
              <option className="fs-6 fw-semibold" value="50">
                50
              </option>
              <option className="fs-6 fw-semibold" value="100">
                100
              </option>
            </select>

          </div>
          <div className="d-flex flex-column flex-sm-row align-items-center gap-2">
            <p className="count text-white fw-semibold fs-6 m-0">
              Showing {rangeStart}-{rangeEnd} of {totalData} entries
            </p>
            <div className="d-flex align-items-center">
              <button
                className={serverPage === 1 ? "page-btn" : "active"}
                disabled={serverPage === 1}
                onClick={() => onPageChangeClient(1)}
              >
                <FirstPageIcon />
              </button>
              <button
                className={serverPage === 1 ? "page-btn" : "active"}
                disabled={serverPage === 1}
                onClick={() => onPageChangeClient(serverPage - 1)}
              >
                <i className="fa-solid fa-angle-left"></i>
              </button>
              {/* {pages.map((page) => (
                <button
                  key={page}
                  onClick={() => onPageChangeClient(page - 1)}
                  className={page + 1 === serverPage ? "active" : "active-btn"}
                >
                  {page}
                </button>
              ))} */}
              <button
                className={
                  serverPage === Math.ceil(totalData / serverPerPage)
                    ? "page-btn"
                    : "active"
                }
                disabled={serverPage === Math.ceil(totalData / serverPerPage)}
                onClick={() => onPageChangeClient(serverPage + 1)}
              >
                <i className="fa-solid fa-angle-right"></i>
              </button>
              <button
                className={
                  serverPage === Math.ceil(totalData / serverPerPage)
                    ? "page-btn"
                    : "active"
                }
                disabled={serverPage === Math.ceil(totalData / serverPerPage)}
                onClick={() =>
                  onPageChangeClient(Math.ceil(totalData / serverPerPage))
                }
              >
                <LastPageIcon />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* client side pagination  */}
      {type === "client" && totalData > 0 && (
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center justify-content-center">
            <span className="text-white fw-semibold fs-6">Row Per Page :-</span>
            <select
              className="mx-2 pageOption"
              onChange={(e) => onRowsPerPageChange(e.target.value)}
            >
              <option className="fs-6 fw-semibold" value="5">
                5
              </option>
              <option className="fs-6 fw-semibold" value="10" selected>
                10
              </option>
              <option className="fs-6 fw-semibold" value="25">
                25
              </option>
              <option className="fs-6 fw-semibold" value="50">
                50
              </option>
              <option className="fs-6 fw-semibold" value="100">
                100
              </option>
            </select>
          </div>
          <div className="d-flex flex-column flex-sm-row align-items-center gap-2">
            <p className="count text-white fw-semibold fs-6 m-0">
              Showing {parseInt(serverPage * serverPerPage + 1)} - {totalCount} of {totalData} entries
            </p>
            <div className="d-flex align-items-center">
              <button
                className={serverPage === 0 ? "page-btn" : "active"}
                disabled={serverPage === 0}
                onClick={() => onPageChangeClient(0)}
              >
                <FirstPageIcon />
              </button>
              <button
                className={serverPage === 0 ? "page-btn" : "active"}
                disabled={serverPage === 0}
                onClick={() => onPageChangeClient(serverPage - 1)}
              >
                <i className="fa-solid fa-angle-left"></i>
              </button>
              {/* {pages.map((page) => (
                <button
                  key={page}
                  onClick={() => onPageChangeClient(page - 1)}
                  className={page - 1 === serverPage ? "active" : "active-btn"}
                >
                  {page}
                </button>
              ))} */}
              <button
                className={
                  serverPage === Math.ceil(totalData / serverPerPage) - 1
                    ? "page-btn"
                    : "active"
                }
                disabled={serverPage === Math.ceil(totalData / serverPerPage) - 1}
                onClick={() => onPageChangeClient(serverPage + 1)}
              >
                <i className="fa-solid fa-angle-right"></i>
              </button>
              <button
                className={
                  serverPage === Math.ceil(totalData / serverPerPage) - 1
                    ? "page-btn"
                    : "active"
                }
                disabled={serverPage === Math.ceil(totalData / serverPerPage) - 1}
                onClick={() =>
                  onPageChangeClient(Math.ceil(totalData / serverPerPage) - 1)
                }
              >
                <LastPageIcon />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pagination;
